<template>
	<div class="btn-group">
	<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'bsf-btn-group',
		components: {
		},
		props: [],
		data() {
			return {
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				console.log()
			})
		},
		computed: {

		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	@import (reference) "../../assets/lib/icon.less";
</style>


// WEBPACK FOOTER //
// btngroup.vue?bc1276d8